import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

function TeamLogin({ setTeam }) {
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [isFirstLogin, setIsFirstLogin] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const response = await fetch('/api/team/auth/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ code, name: isFirstLogin ? name : undefined }),
      });

      const data = await response.json();
      
      if (!response.ok) {
        if (data.error === "Team name is required for first login") {
          setIsFirstLogin(true);
          setError('Пожалуйста, введите название команды для первого входа');
        } else {
          setError(data.error || 'Ошибка аутентификации');
        }
      } else {
        localStorage.setItem('teamSessionKey', data.session_key);
        setTeam({ 
          id: data.team_id,
          name: data.team_name, 
          sessionKey: data.session_key 
        });
        navigate('/map');
      }
    } catch (err) {
      setError('Ошибка сети. Проверьте подключение.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <h2>Вход команды</h2>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="code">Код команды:</label>
            <input
              id="code"
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Введите код команды"
              required
              disabled={loading}
            />
          </div>

          {isFirstLogin && (
            <div className="form-group">
              <label htmlFor="name">Название команды:</label>
              <input
                id="name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Введите название команды"
                required
                disabled={loading}
              />
            </div>
          )}

          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Вход...' : 'Войти'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default TeamLogin;